import { getUserAccessLevel } from "./setup";

const BASE_HEIGHT = 900;   // reference viewport height (px)
const BASE_ZOOM = 3.2;   // zoom that touches top & bottom at BASE_HEIGHT

const MIN_LEFT_PADDING = window.innerWidth * 1; // small screen
const MAX_LEFT_PADDING = window.innerWidth * 0.62; // large screen
const MIN_WIDTH = 900; // window width where max padding is reached
const MAX_WIDTH = 2200; // window width where min padding is reached

const BATTERY_THRESHOLD = 25;

const STYLE = "styles/mapbox/dark-v11";
const token = 'access_token=pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function computeGlobeZoom() {
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Skip mobile
    if (width < 900) {
        return 2;
    }

    // Logarithmic scaling (Mapbox zoom is log2-based)
    const scale = height / BASE_HEIGHT;
    const zoom = BASE_ZOOM + Math.log2(scale);

    return zoom;
}

function computeLeftPadding() {
    const width = window.innerWidth;

    if (width < MIN_WIDTH) return MIN_LEFT_PADDING;
    if (width > MAX_WIDTH) return MAX_LEFT_PADDING;

    // Linear interpolation
    const t = (width - MIN_WIDTH) / (MAX_WIDTH - MIN_WIDTH);
    return MIN_LEFT_PADDING + t * (MAX_LEFT_PADDING - MIN_LEFT_PADDING);
}

function updateCamera(map) {
    const zoom = computeGlobeZoom();
    map.current.setZoom(zoom);

    const leftPadding = computeLeftPadding();
    map.current.setPadding({
        left: leftPadding,
        right: 0,
        top: 0,
        bottom: 0
    });
}

function enableInteractivity(map) {
    map.current.boxZoom.enable();
    map.current.doubleClickZoom.enable();
    map.current.dragPan.enable();
    map.current.dragRotate.enable();
    map.current.keyboard.enable();
    map.current.scrollZoom.enable();
    map.current.touchZoomRotate.enable();
    map.current.interactive = true;
}

function setMapIcons(map, isVisible) {
    if (!map.current) return;
    const style = map.current.getStyle();
    if (!style) return;

    const layers = style.layers;
    // console.log(layers)
    const visibility = isVisible ? 'visible' : 'none';

    layers.forEach((layer) => {
        if (layer.type === 'symbol') {
            map.current.setLayoutProperty(layer.id, 'visibility', visibility);
        }
    });
}

function disableInteractivity(map) {
    map.current.boxZoom.disable();
    map.current.doubleClickZoom.disable();
    map.current.dragPan.disable();
    map.current.dragRotate.disable();
    map.current.keyboard.disable();
    map.current.scrollZoom.disable();
    map.current.touchZoomRotate.disable();
    map.current.interactive = false;
    map.current.setBearing(0);
    map.current.setPitch(0);
}

function adjustSpin(map, enable_spin) {
    // Subtle rotation
    let rotationSpeed = 1;
    let origin = map.current.getCenter();
    if (enable_spin) {
        function spin() {
            origin.lng -= rotationSpeed / 60;
            map.current.setCenter(origin, { animate: false });
            if (!map.current.interactive) {
                requestAnimationFrame(spin);
            }
            else {
                map.current.setCenter(map.current.originalCenter);
            }
        }
        spin();
    }
}

function enableMap(map) {
    enableInteractivity(map);
    adjustSpin(map, false);
    setMapIcons(map, true);
}

function disableMap(map, enable_spin = true) {
    disableInteractivity(map);
    updateCamera(map);
    adjustSpin(map, enable_spin);
    setMapIcons(map, false);
}


function setDevicePointColour(device, user_type) {
    if (!device.active && getUserAccessLevel(user_type, 'technician')) {
        return { feature_colour: '#555555', zIndex: 4 };
    }
    else {
        if (device.connected_state == 'sleeping') {
            return { feature_colour: '#555555', zIndex: 4 };
        }
        else if (device.connected_state != "online") {
            return { feature_colour: "#ff667c", zIndex: 3 };
        }
        else if (device.battery <= BATTERY_THRESHOLD && getUserAccessLevel(user_type, 'technician')) {
            return { feature_colour: "#edaa00", zIndex: 2 };
        }
        else {
            return { feature_colour: "#58ba2d", zIndex: 1 };
        }
    }
}

function setGroupPolygonColour(group, user_type) {
    if (!group.all_updated) {
        return "#ff667c";
    }
    else if (group.devices_monitored > 0 && getUserAccessLevel(user_type, 'technician')) {
        return "#edaa00";
    }
    else {
        return "#58ba2d";
    }
}

function setCameraDeviceIcon(device, user_type) {
    if (!device.active && getUserAccessLevel(user_type, 'technician')) {
        var icon_image = 'cameraIconInactive';
    }
    else {
        if (device.connected_state == 'offline') {
            var icon_image = 'cameraIconOffline';
        }
        else if (device.battery <= BATTERY_THRESHOLD && getUserAccessLevel(user_type, 'technician')) {
            var icon_image = 'cameraIconWarning';
        }
        else {
            var icon_image = 'cameraIconOnline';
        }
    }

    return icon_image;
}


export {
    enableInteractivity, disableInteractivity, setMapIcons, adjustSpin, enableMap, disableMap, updateCamera, setDevicePointColour, setGroupPolygonColour, setCameraDeviceIcon
}